module.exports = __webpack_public_path__ + "static/media/layout.80b2a084.png";